function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v5H0v-5ZM0,17.5h30v5H0v-5Z",
    style: {
      fill: "#00bce4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10.833,12.917l.49,1.508-1.283-.932h1.585l-1.282.932.49-1.508Z",
    style: {
      fill: "#00bce4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M10.833,15.417l.49,1.508-1.283-.932h1.585l-1.282.932.49-1.508Z",
    style: {
      fill: "#00bce4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M15,14.167l.49,1.508-1.283-.932h1.585l-1.283.932.491-1.508Z",
    style: {
      fill: "#00bce4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M19.167,12.917l.49,1.508-1.283-.932h1.585l-1.283.932.491-1.508Z",
    style: {
      fill: "#00bce4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M19.167,15.417l.49,1.508-1.283-.932h1.585l-1.283.932.491-1.508Z",
    style: {
      fill: "#00bce4"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHn);
export default __webpack_public_path__ + "static/media/HN.d752014f556918b4f09d284537b491ff.svg";
export { ForwardRef as ReactComponent };